/**
 * SEO component for per-page meta tags.
 * React 19 natively hoists <title>, <meta>, and <link> elements rendered
 * from any component into the document <head>, so this works without any
 * external library (e.g. react-helmet).
 */
import React from "react";

export const SEO = ({
  title,
  description,
  canonical,
  ogImage = "https://customer-assets.emergentagent.com/job_work-space-hub/artifacts/5xi2y6ua_Conference%20Room%20%28Ocean%29.jpg",
  ogType = "website",
}) => {
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "https://www.workcoastal.com");
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default SEO;
